import React, {useEffect, useState} from 'react';
import {Link, useNavigate, useParams} from 'react-router-dom';
import Layout from '../components/Layout';
import ConfirmModal from '../../components/ConfirmModal';
import {api} from '../../api';


export default function BankReconciliationDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [recon, setRecon] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  useEffect(() => {
    api(`/bank-reconciliations/${id}`).then(r => r.json()).then(setRecon);
  }, [id]);

  const handleDelete = async () => {
    await api(`/bank-reconciliations/${id}`, { method: 'DELETE' });
    navigate('/accounting/bank-reconciliations');
  };

  if (!recon) return null;

  return (
    <Layout>
      <Link to="/accounting/bank-reconciliations" className="text-emerald-600 hover:text-emerald-800 mb-4 inline-block">&larr; Back to Reconciliations</Link>
      <div className="bg-white rounded-lg shadow mb-6">
        <div className="p-4 md:p-6 border-b">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900">{recon.accountName}</h1>
              <p className="text-gray-600">Statement Date: {recon.statementDate}</p>
            </div>
            <div className="flex items-center gap-3">
              <span className={`px-4 py-2 rounded-full text-sm font-medium ${recon.status === 'COMPLETED' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`}>{recon.status.replace(/_/g, ' ')}</span>
              <button onClick={() => setDeleteModal(true)} className="px-4 py-2 border border-red-300 text-red-600 rounded-lg hover:bg-red-50">Delete</button>
            </div>
          </div>
        </div>
        <div className="p-4 md:p-6 grid grid-cols-1 sm:grid-cols-3 gap-6 border-b">
          <div><p className="text-sm text-gray-500 mb-1">Statement Balance</p><p className="text-xl font-bold text-gray-900">${recon.statementBalance.toFixed(2)}</p></div>
          <div><p className="text-sm text-gray-500 mb-1">Matched Total</p><p className="text-xl font-bold text-gray-900">${(recon.matchedTotal || 0).toFixed(2)}</p></div>
          <div><p className="text-sm text-gray-500 mb-1">Difference</p><p className={`text-xl font-bold ${recon.difference === 0 ? 'text-green-600' : 'text-red-600'}`}>${(recon.difference || 0).toFixed(2)}</p></div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50"><tr><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th><th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th><th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Amount</th><th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase">Matched</th></tr></thead>
            <tbody className="divide-y divide-gray-200">
              {(recon.lines || []).map(line => (
                <tr key={line.id} className={line.matched ? 'bg-green-50' : ''}>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-900">{line.transactionDate}</td>
                  <td className="px-6 py-4 text-gray-600">{line.description || '—'}</td>
                  <td className="px-6 py-4 text-right font-mono">{line.amount.toFixed(2)}</td>
                  <td className="px-6 py-4 text-center">{line.matched ? <span className="text-green-600">✓</span> : <span className="text-gray-400">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {(recon.lines || []).length === 0 && <div className="text-center py-12 text-gray-500">No statement lines.</div>}
        </div>
      </div>
      <ConfirmModal open={deleteModal} title="Delete Reconciliation" message="Are you sure?" onConfirm={handleDelete} onCancel={() => setDeleteModal(false)} />
    </Layout>
  );
}
